import React from "react";
import { ToastContentProps } from "react-toastify";
import styled from "styled-components";
import { Primary } from "@ui/components/containers/primary";
import { RoundedBlock } from "@ui/components/containers/roundedBlock";
import { CheckIcon, ErrorIcon } from "@ui/components/icons";
import { gap } from "@ui/styles/utils";

interface SimpleToastProps extends ToastContentProps {
	type?: "error" | "success";
	title: string;
	message: string;
}
export const SimpleToast: React.FC<SimpleToastProps> = ({ title, message, type }) => {
	return (
		<Container>
			{!!type && <>{type === "error" ? <ErrorIcon /> : <CheckIcon />}</>}
			<Primary>
				<b>{title}</b>
			</Primary>
			<Primary>{message}</Primary>
		</Container>
	);
};

const Container = styled(RoundedBlock)`
	padding: 30px 38px 28px;
	display: flex;
	flex-direction: column;
	${gap(15)};
`;
